// extracted by mini-css-extract-plugin
export default {"wrapper":"TextEditor-module__wrapper--db702","editor":"TextEditor-module__editor--f0957"};